// extracted by mini-css-extract-plugin
export default {"RowItem":"RowItem_RowItem__XlVNV","Label":"RowItem_Label__oepmV","Value":"RowItem_Value__Rn3Pf"};